import classNames from 'classnames';

import { useIsMobile } from '../../../hooks';

import styles from './EpicMoversInternal.module.scss';

const SkeletonLoaderRow = () => {
  const { isMobile } = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.loadingRowMobile}>
        <div className={styles.left}>
          <div className={styles.loadingLogo} />
          <div className={styles.companyInfo}>
            <div
              style={{ width: '40%' }}
              className={classNames(styles.loadingElement, styles.loadingMargin)}
            />
            <div
              style={{ width: '68%' }}
              className={classNames(styles.loadingElement, styles.loadingMargin, styles.loadingMarginTop)}
            />
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.mobileChart}>
            <div className={styles.loadingChart} />
          </div>
          <div>
            <div className={styles.loadingElement} />
            <div className={classNames(styles.loadingElement, styles.loadingMarginTop)} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <tr className={styles.loadingRow}>
      <td>
        <div className={styles.wrapperCompany}>
          <div className={styles.loadingLogo} />
          <div className={styles.companyInfo}>
            <div className={styles.nameAndSymbol}>
              <div className={styles.loadingElement} />
              <div className={classNames(styles.loadingElement, styles.loadingMargin)} />
            </div>
          </div>
        </div>
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
    </tr>
  );
};

export default SkeletonLoaderRow;
